import { RouteConfig } from '../../../../routing/types'

export type PathArgs = any[]

const ROUTE: RouteConfig<PathArgs> = {
  name: 'settings-update-password',
  path: () => '/settings/password',
  type: 'private',
  //
}

export default ROUTE
